import { useCallback, useState, useEffect } from 'react';

import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { createContainer, useContainer } from 'unstated-next';

import { GET_USER_DATA } from '../../../../../config/apiPaths';
import { getUrlParams, getUrls, processApiPath } from '../../../../../utils/url';
import AdminAuthContainer from '../../../AdminAuthContainer';

interface SupportContainerState {
    supportData?: Record<string, any>; // result of the GET_CLASS_DATA_PATH api call
}

type LoadingStatus = 'INITIAL' | 'LOADING' | 'SUCCESS' | 'ERROR';

const useSupportContainer = (state: SupportContainerState = {}) => {
    console.log('SupportContainer');
    const { api } = getUrls();

    const [supportData, setSupportData] = useState<any>();

    const { t: tCommon } = useTranslation('common');

    const { authMode } = useContainer(AdminAuthContainer);

    const search = new URLSearchParams(window.location.search);
    const supportUuid = search.get('support_uuid') || window.localStorage.getItem('support_uuid');

    const [getSupportStatus, setGetSupportStatus] = useState<LoadingStatus>('INITIAL');
    const [errorMessage, setErrorMessage] = useState<string>('');

    const { supportId: supportIdV1 } = useParams<{ supportId?: string }>();
    const { support_id: supportIdV2 } = getUrlParams();
    const supportId = supportIdV1 || supportIdV2 || '';

    const returnErrorMessage = useCallback(
        (error: any): string => {
            console.error(error);
            return tCommon('errorMessage');
        },
        [tCommon]
    );

    const getSupportDataCall = useCallback(async () => {
        const { data } = await axios.get(
            processApiPath(GET_USER_DATA, undefined, {
                support_uuid: supportUuid!,
                support_id: supportId,
                auth_mode: authMode
            })
        );

        if (data?.success === false) {
            throw Error(data?.error);
        }
        return data;
    }, [supportUuid, supportId, authMode]);

    const getSupport = useCallback(async () => {
        setGetSupportStatus('LOADING');

        try {
            const data = state.supportData ?? (await getSupportDataCall());

            setSupportData(data);
            setGetSupportStatus('SUCCESS');
        } catch (err) {
            const errorMsg = returnErrorMessage(err);
            setErrorMessage(errorMsg);
            setGetSupportStatus('ERROR');
        }
    }, [state.supportData, getSupportDataCall, returnErrorMessage]);

    useEffect(() => {
        if (supportId && supportUuid) {
            getSupport();
        }
    }, [supportId, getSupport, supportUuid]);

    return {
        supportId,
        api,
        supportData,
        getSupportStatus,
        errorMessage
    };
};

const SupportContainer = createContainer(useSupportContainer);

export default SupportContainer;
